import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment';
import Linkify from 'linkifyjs/react'

import timestamps from '~/services/timestamps'
import TextEdit from '~/services/textedit'
import { Icon } from '~/components'

import OverflowText from '../OverflowText'


export default class extends React.Component {
    static propTypes = {
		date: PropTypes.string,
		ID: PropTypes.number,
		toggleFlare: PropTypes.func.isRequired,
		newPost: PropTypes.bool,
		parent: PropTypes.number,
		title: PropTypes.string,
		user: PropTypes.object,
		toggleReplyBox: PropTypes.func.isRequired
	};

    state = {
        flared: 'flared' in this.props ? this.props.flared : false
    };

    openReply = () => {
		this.props.toggleReplyBox(true)
	};

    toggleFlare = () => {
		this.props.toggleFlare(this.props.ID)
		this.setState({
			flared: !this.state.flared
		})
	};

    render() {

		let reply = this.props,
			newPost = 'newPost' in this.props && this.props.newPost,
            brandNewConfirmed = moment().diff( moment.utc(reply.date), 'seconds' ) < 10;

		return (
			<div className={"col-sm-12 bg-pale-gray ptop5 pbot5 " + (reply.parent > 0 ? 'reply-sub-item' : 'reply-item') + ( newPost ? ' new-post' : (brandNewConfirmed ? ' new-post-confirmed' : '') )}>
				<div className="reply-content">
					<div className="profile-image-wrapper mright10">
						<Link to={reply.user.link}>
							<div className="profile-image" style={{backgroundImage: 'url(' + reply.user.profile_picture + ')'}}></div>
						</Link>
					</div>
					<p className="small">
						<strong>{reply.user.first + ' ' + reply.user.last}</strong> 
						<span className="mleft5 text-mid-gray">{timestamps.timeSince(reply.date, true)}</span>
					</p>
					<OverflowText type="reply" className="small mbot5"><Linkify>{reply.title}</Linkify></OverflowText>
					{ !('newPost' in this.props) && 
						<p className="small text-mid-gray">
							<span onClick={this.openReply} className="clickable">Reply</span>
							<Icon icon={'flares'} className={'mleft10 clickable ' + (this.state.flared ? 'text-mid-danger' : '')} onClick={this.toggleFlare} /> {reply.flares.length}
						</p> 
					}
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/ContentParts/ReplyParts/ReplyPart-Item.jsx